/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DisputeTransferDetails = {
  /**
   * The disputed transfer's ID.
   */
  transferID: string;
};

/** @internal */
export const DisputeTransferDetails$inboundSchema: z.ZodType<
  DisputeTransferDetails,
  z.ZodTypeDef,
  unknown
> = z.object({
  transferID: z.string(),
});
/** @internal */
export type DisputeTransferDetails$Outbound = {
  transferID: string;
};

/** @internal */
export const DisputeTransferDetails$outboundSchema: z.ZodType<
  DisputeTransferDetails$Outbound,
  z.ZodTypeDef,
  DisputeTransferDetails
> = z.object({
  transferID: z.string(),
});

export function disputeTransferDetailsToJSON(
  disputeTransferDetails: DisputeTransferDetails,
): string {
  return JSON.stringify(
    DisputeTransferDetails$outboundSchema.parse(disputeTransferDetails),
  );
}
export function disputeTransferDetailsFromJSON(
  jsonString: string,
): SafeParseResult<DisputeTransferDetails, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisputeTransferDetails$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisputeTransferDetails' from JSON`,
  );
}
